import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError } from 'rxjs';
import { AuthService } from "../../../auth/auth.service";
import { LoggerService } from "@teammood/shared/util/logger";
import { Router } from "@angular/router";

export const http40xInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next:
  HttpHandlerFn) => {
  const authService = inject(AuthService);
  const logger = inject(LoggerService);
  const router = inject(Router);

  return next(req).pipe(
    catchError(async (err) => {

      if (err.status === 401) {
        authService.removeToken();

        logger.info("Not authenticated, transition to login");
        await router.navigate(['/login']);
      }

      if (err.status === 403) {
        if (authService.isAuthenticated()) {
          logger.error("http 403 Not authorized", err);
          logger.info("Not authorized, transition to home");
        } else {
            await router.navigate(['/login']);
        }
      }
      
      throw err;
    })
  );
};